import { render, staticRenderFns } from "./BlockedView.vue?vue&type=template&id=074d23de&scoped=true&"
import script from "./BlockedView.vue?vue&type=script&lang=js&"
export * from "./BlockedView.vue?vue&type=script&lang=js&"
import style0 from "./BlockedView.vue?vue&type=style&index=0&id=074d23de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d23de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
